import { render, staticRenderFns } from "./personal-achievement.vue?vue&type=template&id=3bac5662&"
import script from "./personal-achievement.vue?vue&type=script&lang=js&"
export * from "./personal-achievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports